import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Box,
} from "@material-ui/core";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";

export default function CheckDialog({ data,openDialog ,setOpenDialog}) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    // الضغط بالزر الأيمن
    const handleContextMenu = (e) => {
        e.preventDefault();

        // هنا تضع القيم التي تريدها من الصف
        setUsername("admin");
        setPassword("123456");

        // setOpen(true);
    };

    const excelHeaders = [
        { label: "الرقم", key: "id" },
        { label: "الباركود", key: "optype" },
        { label: "الصنف", key: "item_name" },
        { label: "المجموعة", key: "qty" },
        { label: "الشراء", key: "price" },
        { label: "البيع", key: "tax" },
    ];

    // التصدير
    const handleExport = () => {
        if (username === "admin" && password === "admin123123") {

        }
        // const text =
        //   `اسم المستخدم: ${username}\n` +
        //   `كلمة المرور: ${password}`;

        // const blob = new Blob([text], {
        //   type: "text/plain;charset=utf-8",
        // });

        // const url = window.URL.createObjectURL(blob);

        // const a = document.createElement("a");
        // a.href = url;
        // a.download = "بيانات_المستخدم.txt";
        // a.click();

        // window.URL.revokeObjectURL(url);
    };

    return (
        <>
            {/* الجدول */}
            <Box
                onContextMenu={handleContextMenu}
                style={{
                    width: "100%",
                    border: "1px solid #ddd",
                    padding: 20,
                    cursor: "context-menu",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                    }}
                >
                    <thead>
                        <tr>
                            <th>رقم</th>
                            <th>اسم المستخدم</th>
                            <th>الحالة</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>admin</td>
                            <td>فعال</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>mousa</td>
                            <td>فعال</td>
                        </tr>
                    </tbody>
                </table>
            </Box>

            {/* نافذة التصدير */}
            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle
                    style={{
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                >
                    تصدير بيانات المستخدم
                </DialogTitle>

                <DialogContent>
                    <Box
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 15,
                            paddingBottom: 15,
                            paddingTop: 5,
                        }}
                    >
                        <TextField
                            label="اسم المستخدم"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            variant="outlined"
                            fullWidth
                            size="small"
                        />

                        <TextField
                            label="كلمة المرور"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="password"
                        />
                        <CSVLink
                            separator={";"}
                            filename={"Items"}
                            data={data}
                            headers={excelHeaders}
                        >
                            {" "}
                            <Button
                                disabled={(username !== "admin"||  password !== "admin123123")}
                                variant="contained"
                                startIcon={<TableChart />}
                                size="large"
                                color="primary"
                                style={{ borderRadius: 0 }}
                                // className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                            >
                                {"تصدير"}
                            </Button>
                        </CSVLink>
                        {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={handleExport}
                            fullWidth
                            style={{
                                height: 42,
                                fontWeight: "bold",
                            }}
                        >
                            تصدير
                        </Button> */}
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}